export const API_URL =
  process.env.EXPO_PUBLIC_API_URL || "https://icare.threls.dev/api";
export const DISABLE_PASSWORD_ACTION =
  process.env.EXPO_PUBLIC_DISABLE_PASSWORD_ACTION === "true";
export const SENTRY_DSN = process.env.EXPO_PUBLIC_SENTRY_DSN ?? "";
export const SENTRY_TRACE_SAMPLING_RATE = Number(
  process.env.EXPO_PUBLIC_SENTRY_TRACING_RATE ?? 0.2,
);
export const SENTRY_ENVIRONMENT =
  process.env.EXPO_PUBLIC_SENTRY_ENVIRONMENT ??
  process.env.VERCEL_ENV ?? // Vercel provides: production, preview, development
  process.env.NODE_ENV ??
  "development";
export const LOCATION_ID = Number(process.env.LOCATION_ID ?? 1);

export const DISABLE_OFFLINE_PERSISTENCE =
  process.env.EXPO_PUBLIC_DISABLE_OFFLINE_PERSISTENCE === "true";
export const DISABLE_OFFLINE_RETRIEVAL =
  process.env.EXPO_PUBLIC_DISABLE_OFFLINE_RETRIEVAL === "true";
